import { message, Space, Typography, Upload } from 'antd';
import {
  RcFile,
  UploadChangeParam,
  UploadFile,
  UploadProps,
} from 'antd/lib/upload';
import { DragEvent, memo, useState } from 'react';
import styled from 'styled-components';

import { isFileSizeLess } from 'src/features/programsV2/utils/validateFileSize';

const { Text } = Typography;

interface CreateInstructorAvatarProps {
  onChange?: (file: RcFile) => void;
}

export const CreateInstructorAvatar = memo<CreateInstructorAvatarProps>(
  ({ onChange }) => {
    const [fileImage, setFileImage] = useState({ url: '', name: '' });

    const handleDropValidation = (e: DragEvent<HTMLDivElement>) => {
      e.preventDefault();
      const droppedFiles = e.dataTransfer.files;

      if (droppedFiles.length) {
        const file = droppedFiles[0] as RcFile;
        const fileType = file.type;

        const isValidSize = isFileSizeLess(file, 10);
        if (!isValidSize) {
          return;
        }

        if (fileType !== 'image/png' && fileType !== 'image/jpeg') {
          message.error(
            `${file.name.toLowerCase()} - não é um arquivo válido. Apenas arquivos PNG/JPEG são permitidos.`
          );
        }
      }
    };

    const handleChange: UploadProps['onChange'] = (
      info: UploadChangeParam<UploadFile>
    ) => {
      const file = info.file.originFileObj as RcFile;

      const isValidSize = isFileSizeLess(file, 10);
      if (!isValidSize) {
        return;
      }

      setFileImage({ url: URL.createObjectURL(file), name: file.name });
      onChange?.(file);
    };

    return (
      <UploadWrapper direction='horizontal' size='large'>
        <Upload
          name='avatar'
          listType='picture-card'
          showUploadList={false}
          onChange={handleChange}
          onDrop={handleDropValidation}
          accept='image/png, image/jpeg'
        >
          {fileImage.url ? (
            <img
              src={fileImage.url}
              alt='Avatar do treinador'
              style={{
                margin: '4px',
                maxWidth: '260px',
                height: '250px',
                borderRadius: '50%',
                overflow: 'hidden',
                objectFit: 'cover',
              }}
            />
          ) : (
            <WithoutImgContentWrapper>
              <IconWrapper>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='37'
                  height='37'
                  viewBox='0 0 37 37'
                  fill='none'
                >
                  <path
                    d='M3.3333 36.5C2.41663 36.5 1.63192 36.1736 0.97915 35.5209C0.326383 34.8681 0 34.0834 0 33.1667V3.8333C0 2.91663 0.326383 2.13192 0.97915 1.47915C1.63192 0.826383 2.41663 0.5 3.3333 0.5H22.9667V3.8333H3.3333V33.1667H32.6667V13.5667H36V33.1667C36 34.0834 35.6736 34.8681 35.0209 35.5209C34.3681 36.1736 33.5834 36.5 32.6667 36.5H3.3333ZM28.6667 11.9V7.86665H24.6334V4.53335H28.6667V0.5H32V4.53335H36.0334V7.86665H32V11.9H28.6667ZM6 28.4334H30L22.7 18.7L16.4667 26.9334L11.8334 20.8L6 28.4334Z'
                    fill='#7D7D7D'
                  />
                </svg>
                <Text
                  style={{
                    color: '#1668DC',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  }}
                >
                  Clique para carregar
                </Text>
              </IconWrapper>
              <Text
                style={{
                  fontSize: '16px',
                }}
              >
                ou arraste e solte
              </Text>
              <Text style={{ color: '#FFFFFF73' }}>.png ou .jpg 500pixel</Text>
            </WithoutImgContentWrapper>
          )}
        </Upload>

        {!!fileImage.name && (
          <Text style={{ fontSize: '20px' }}>{fileImage.name}</Text>
        )}
      </UploadWrapper>
    );
  }
);

const UploadWrapper = styled(Space)`
  width: 100%;
  justify-content: center;
  .ant-upload.ant-upload-select-picture-card {
    width: 260px;
    height: 260px;
    border-radius: 50%;
  }

  img {
    width: 100%;
  }
`;

const WithoutImgContentWrapper = styled.div`
  gap: 4px;
  display: flex;
  flex-direction: column;
`;

const IconWrapper = styled.div`
  gap: 16px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
